export default __webpack_public_path__ + "static/media/email.6986e212.svg";